import { handleHttpResponse } from "../../utils/http_response_utils";

export const getCompanyNames = async () => {
  const accessToken = localStorage.getItem("access-token");
  const response = await fetch("/api/get-company-names", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return await handleHttpResponse(response);
};

export const getCompanyNamesAuto4client = async () => {
  const accessToken = localStorage.getItem("access-token");
  const response = await fetch("/api/get-company-names-auto4client", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return await handleHttpResponse(response);
};

export const getCompanyNamesCompJson = async () => {
  const accessToken = localStorage.getItem("access-token");
  const response = await fetch("/api/get-company-names-comp-json", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return await handleHttpResponse(response);
};

export const getJsonAvailableYears = async () => {
  const accessToken = localStorage.getItem("access-token");
  const response = await fetch("/api/get-json-available-years", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return await handleHttpResponse(response);
};
